import { useQuery, useQueryClient } from 'react-query'
import { getPaymentMethods } from '../api/paymentsApi'
import type { PaymentMethodsResponse } from '../api/types'

export const PAYMENT_METHODS_QUERY_KEY = ['payment-methods'] as const

export const usePaymentMethodsQuery = (enabled = true) => {
  return useQuery<PaymentMethodsResponse>(PAYMENT_METHODS_QUERY_KEY, getPaymentMethods, {
    enabled,
    staleTime: 60_000,
    retry: 1,
  })
}

export const useInvalidatePaymentMethods = () => {
  const qc = useQueryClient()
  return () => qc.invalidateQueries(PAYMENT_METHODS_QUERY_KEY)
}
